export default [
  {
    path: 'relatorios/pagamentos',
    name: 'pagamentos',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Pagamentos',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Pagamentos'},
      ]
    }
  }
]
